import { render, staticRenderFns } from "./CustomFormQuestion.vue?vue&type=template&id=2c1053a0"
import script from "./CustomFormQuestion.vue?vue&type=script&lang=js"
export * from "./CustomFormQuestion.vue?vue&type=script&lang=js"
import style0 from "./CustomFormQuestion.vue?vue&type=style&index=0&id=2c1053a0&prod&scope=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports